export default {"src":"/_next/static/media/trash.e4100884.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};